export { default } from "./useGetDocumentTemplate";
